import { render, staticRenderFns } from "./PledgeReport.vue?vue&type=template&id=f145755c"
import script from "./PledgeReport.vue?vue&type=script&lang=js"
export * from "./PledgeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports